import { TaskType } from "types";

export const getTaskTypeName = (value: TaskType): string => {
  switch (value) {
    case "Calc":
      return "Laden- und Onlinepreisberechnung";
    case "Sync":
      return "Kartensynchronisation";
    case "Stock":
      return "Bestandssynchronisation";
  }
};
